import React from 'react';
import { useDevMode } from '../contexts/DevModeContext';
import './UnderTheHood.css';

const UnderTheHood = ({ title = "Under the hood (for developers)", children, className = '' }) => {
  const { isDevMode } = useDevMode();

  if (!isDevMode) {
    return null;
  }

  return (
    <div className={`under-the-hood ${className}`}>
      <div className="under-the-hood-header">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" />
          <path d="M2 17L12 22L22 17" />
          <path d="M2 12L12 17L22 12" />
        </svg>
        <h4>{title}</h4>
      </div>
      <div className="under-the-hood-content">
        {children}
      </div>
    </div>
  );
};

export default UnderTheHood;

